export const noteOptions = [
    'Eat',
    'Activity',
    'Sleep',
    'Poop',
    'Pee',
    'Poop & Pee',
    'Other'
]